import Reveal, { SectionLabel } from "@/components/Reveal";
import { Check } from "lucide-react";

const LAYERS = [
  { key: "zones", label: "Key Zones", desc: "Automated support, resistance & liquidity pools", testid: "indicator-layer-toggle-zones" },
  { key: "ribbon", label: "Dynamic EMA Ribbon", desc: "Trend direction & momentum at a glance", testid: "indicator-layer-toggle-ribbon" },
  { key: "sweeps", label: "Liquidity Sweeps", desc: "Marks where stops were hunted before reversal", testid: "indicator-layer-toggle-sweeps" },
  { key: "fvg", label: "Fair Value Gaps", desc: "Institutional imbalance zones for precise entries", testid: "indicator-layer-toggle-fvg" },
];

const Indicator = () => (
  <section id="indicator" className="relative py-24 lg:py-36 bg-panel/30 border-y border-line/60" data-testid="indicator-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <div className="lg:col-span-5 lg:sticky lg:top-28">
        <Reveal>
          <SectionLabel>The Indicator</SectionLabel>
          <h2 className="mt-5 font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-50 leading-tight" data-testid="indicator-title">
            One chart.
            <span className="text-gold-gradient"> Complete clarity.</span>
          </h2>
          <p className="mt-6 text-sm sm:text-base text-slate-400 leading-relaxed max-w-md">
            The custom-coded Atlas indicator layers institutional-grade analysis directly onto your
            chart. Watch it working — real footage, exactly as members see it.
          </p>
        </Reveal>

        <div className="mt-8 space-y-3">
          {LAYERS.map((l, i) => (
            <Reveal key={l.key} delay={0.08 * i}>
              <div
                data-testid={l.testid}
                className="flex items-center justify-between gap-4 border border-line rounded-md px-5 py-4 bg-card2/30"
              >
                <div>
                  <p className="font-display font-bold text-sm sm:text-base text-slate-100">{l.label}</p>
                  <p className="text-xs text-slate-500 mt-1">{l.desc}</p>
                </div>
                <span className="w-7 h-7 shrink-0 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center">
                  <Check size={13} className="text-gold" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="lg:col-span-7">
        <Reveal delay={0.2}>
          <div className="glass-panel gold-ring chart-frame border border-line p-4 sm:p-6" data-testid="indicator-chart-panel">
            <div className="flex items-center justify-between mb-4 px-1">
              <span className="font-mono text-[11px] tracking-[0.25em] text-slate-300">XAUUSD · REAL INDICATOR FOOTAGE</span>
              <span className="flex items-center gap-2 font-mono text-[10px] tracking-widest text-gold/80">
                <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" /> RECORDED LIVE
              </span>
            </div>
            <video
              src="/atlas-indicator-demo.mp4"
              poster="/atlas-indicator-poster.jpg"
              autoPlay
              muted
              loop
              playsInline
              className="w-full h-auto rounded-sm border border-line/60"
              data-testid="indicator-demo-video"
            />
            <p className="mt-4 px-1 text-[11px] text-slate-500">
              The Atlas indicator running on live charts — zones, confluence and structure, exactly as members see it.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Indicator;
